export var BusinessLiveAccessActorType;
(function (BusinessLiveAccessActorType) {
    BusinessLiveAccessActorType["Admin"] = "ADMIN";
    BusinessLiveAccessActorType["Business"] = "BUSINESS";
})(BusinessLiveAccessActorType || (BusinessLiveAccessActorType = {}));
//# sourceMappingURL=BusinessLiveAccessActorType.js.map